export default __webpack_public_path__ + "static/media/Check.6989aa23.svg";